var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { withAngularState } from '@/shared/services/StateService';
import withIntl from '@/shared/components/withIntl';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import DataProvider from '@/shared/providers/DataProvider';
import ModalProvider from '@/shared/providers/ModalProvider';
import TaskTimerProvider from './TaskTimerProvider';
export const withModalProvider = Component => (_a) => {
    var passThroughProps = __rest(_a, []);
    return (_jsx(ModalProvider, { children: _jsx(Component, Object.assign({}, passThroughProps)) }));
};
export const withDataProvider = Component => (_a) => {
    var passThroughProps = __rest(_a, []);
    return (_jsx(DataProvider, { children: _jsx(Component, Object.assign({}, passThroughProps)) }));
};
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
export const withQueryClient = Component => (_a) => {
    var passThroughProps = __rest(_a, []);
    return (_jsx(QueryClientProvider, Object.assign({ client: queryClient }, { children: _jsx(Component, Object.assign({}, passThroughProps)) })));
};
export const withTaskTimerProvider = Component => (_a) => {
    var passThroughProps = __rest(_a, []);
    return (_jsx(TaskTimerProvider, { children: _jsx(Component, Object.assign({}, passThroughProps)) }));
};
const AppProviders = WrappedComponent => 
// @ts-ignore
withAngularState(withIntl(withQueryClient(WrappedComponent)));
export default AppProviders;
